import type { CreditCardTransaction } from '@/lib/credit-card-transactions-db'

/** "1 transaction" / "n transactions". */
export function transactionCountLabel(count: number): string {
  return `${count.toLocaleString('en-US')} ${count === 1 ? 'transaction' : 'transactions'}`
}

/** The row's description, falling back to the vendor, then to an em dash. */
export function transactionDescription(row: Pick<CreditCardTransaction, 'description' | 'vendor'>): string {
  const description = row.description.trim()
  if (description !== '') return description
  const vendor = row.vendor?.trim() ?? ''
  return vendor !== '' ? vendor : '—'
}
